import { render, staticRenderFns } from "./ScalingSettings.vue?vue&type=template&id=4b9cbde2&scoped=true&"
import script from "./ScalingSettings.vue?vue&type=script&lang=ts&"
export * from "./ScalingSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ScalingSettings.vue?vue&type=style&index=0&id=4b9cbde2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9cbde2",
  null
  
)

export default component.exports